import { render } from "./HelloWorld.vue?vue&type=template&id=12e74237&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=12e74237&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12e74237"

export default script